import { format } from 'date-fns';
import React, { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from 'reactstrap';
import { Button, Hyperlink, IconInput } from 'ui-kit-takeat';
import { CurrencyInput } from '~/components/CurrencyInput';
import { useAuth } from '~/context/AuthContext';
import { useCart } from '~/context/OrderingSystem/Cart';
import { usePos } from '~/context/PosContext';
import apiClube from '~/services/apiClube';
import formatValue from '~/utils/formatValue';
import { BANESTES_METHOD, CLUBE_METHOD } from '~/utils/consts';
import {
  AddPaymentForm,
  DropdownToggleStyled,
  DropDowxStyledButton,
  StyledMaquininhaButton,
  TooltipPinpadStyled,
} from '~/components/PaymentForm/styles';
import { Button as NewButton } from 'takeat-design-system-ui-kit';
import api from '~/services/api';
import { BsChat } from 'react-icons/bs';
import {
  Container,
  PaymentsMade,
  PaymentsOptions,
  PaymentsPinpadHeader,
  ProductsContainerBox,
  ProductsContainerBoxComplements,
  Value,
  ValuesArea,
} from './styles';
import { ReactComponent as Alert } from '../../../../assets/img/alert.svg';
import { ReactComponent as ChevronDown } from '../../../../assets/img/ChevronDown.svg';
import { ReactComponent as DisabledAlert } from '../../../../assets/img/gray-alert.svg';
import { PaymentRow } from './PaymentRow';
import { AreaSeparator } from '../styles';
import { Comment, ComplementTag } from '../Cart/CartItem/styles';
import { BackBalconyButton } from '../../BalconyPaymentAreaPinpad/styles';
import { ReactComponent as BackIcon } from '../../../../assets/img/back.svg';
import { TransparentTooltip } from '~/components/transparentTooltip';

export const PaymentsPinpad = ({
  handleSelectedPaymentComponent,
  totalToShow,
  balcony,
  balconySession,
  onResetPinpadOperation,
  onStartPinpadPayment,
  clubInfo,
  clientCashback,
  setClientCashback,
  paymentsSession,
  setPaymentsSession,
  setMetodoAndPaymentOption,
  left,
  setLeft,
  value,
  setValue,
  paid,
  hasMoneyMethod,
  handleStoneTransactions,
  loadingPos,
  toggleCancelPos,
  modalCancelPos,
  handleCancelStoneTransactions,
  allPaymentMethods,
  favoriteMethods,
  paymentMethods,
  checkStonePending,
  savePaymentAsync,
  getPayments,
  total_payments,
  setPayments,
  payments,
  rest,
}) => {
  const { user, setData, token } = useAuth();
  const { cart } = useCart();
  const {
    stoneTransactions,
    cancelStoneTransactionsBalcony,
    cancelAllStoneTransactions,
  } = usePos();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDrop = () => setDropdownOpen((prevState) => !prevState);
  const [metodo, setMetodo] = useState('Outros');
  const [clientRegister, setClientRegister] = useState(true);
  const [loadingCashback, setLoadingCashback] = useState(false);
  const [loading, setLoading] = useState(false);
  const discount =
    parseFloat(balcony?.session?.discount?.replace(',', '.')) || 0;

  useEffect(() => {
    if (balconySession?.session?.id) {
      getPayments(balconySession?.session?.id);
    }
  }, [balcony?.session?.id]);

  const getCashback = useCallback(async () => {
    try {
      let login_club;
      setLoadingCashback(true);

      if (!user.club_login) {
        login_club = await apiClube.post('/public/sessions/takeat', {
          token: user.token_clube,
        });

        localStorage.setItem(
          '@gddashboard:user',
          JSON.stringify({
            ...user,
            club_login: login_club.data.token,
            minimo: login_club.data.user?.settings[0]?.minimo,
          })
        );

        setData((state) => {
          return {
            ...state,
            user: {
              ...user,
              club_login: login_club.data.token,
              minimo: login_club.data.user?.settings[0]?.minimo,
            },
          };
        });
      }

      const response = await apiClube.get(`/store/cashback/${clubInfo.phone}`, {
        headers: {
          Authorization: `Bearer: ${user.club_login || login_club.data.token}`,
        },
      });

      setClientCashback(response.data);
    } catch (err) {
      setClientCashback({ date: null, value: 0 });
      if (err.response?.data?.errorType === 'default_error') {
        toast.error(
          <span>
            Telefone não cadastrado no <b>Clube!</b>
          </span>
        );
      } else {
        toast.error(
          'Não foi possível buscar o cashback referente a este telefone'
        );
      }
    } finally {
      setClientRegister(false);
    }
    setLoadingCashback(false);
  }, [user.club_login, clubInfo.phone]);

  function getLeftName() {
    if (discount) {
      if (total_payments > 0 && total_payments > discount) {
        return 'Restante';
      }
      if (total_payments > 0 && total_payments < discount && hasMoneyMethod) {
        return 'Troco';
      }
      if (total_payments > 0 && total_payments < discount && !hasMoneyMethod) {
        return 'Extra';
      }
      if (total_payments < 0 && hasMoneyMethod) {
        return 'Troco';
      }
      if (total_payments < 0 && !hasMoneyMethod) {
        return 'Extra';
      }
      return 'Restante';
    }
    if (total_payments < 0 && !hasMoneyMethod) {
      return 'Extra';
    }
    if (rest < 0) {
      return 'Troco';
    }
    if (total_payments < 0) {
      return 'Troco';
    }
    return 'Restante';
  }

  useEffect(() => {
    if (user.has_clube && clubInfo.phone?.length === 15) {
      getCashback();
    }
    if (clubInfo.phone?.length < 15) {
      setClientRegister(true);
      setClientCashback({ date: null, value: 0 });
    }
  }, [clubInfo.phone]);

  useEffect(() => {
    if (
      clubInfo.date.length === 10 &&
      clientCashback.date &&
      format(new Date(clientCashback.date.slice(0, -1)), 'dd/MM/yyyy') !==
      clubInfo.date
    ) {
      toast.error('Data informada não coincide com a cadastrada');
    }
  }, [clubInfo.date]);

  const handleCancelPendingPos = () => {
    if (
      window.confirm('Tem certeza que deseja cancelar os pagamentos pendentes?')
    ) {
      cancelAllStoneTransactions()
        .then(async () => {
          const stoneTransactionPendingId = stoneTransactions.find(
            (transaction) => transaction.status === 'pending'
          ).payment_balcony_id;
          try {
            await api.delete(
              `restaurants/payments/${stoneTransactionPendingId}`
            );
          } catch (error) {
            toast.error('Erro ao deletar pagamento');
          }
        })
        .catch(() => {
          console.log('Erro ao cancelar pagamentos pendentes');
        });
    }
  };

  const [methodsFiltered, setMethodsFiltered] = useState([]);

  const prohibitedPaymentMethods = [
    CLUBE_METHOD, //  Resgate Clube
    572, //  Pagamento Online iFood
    2548, // Cartão de Crédito Online
    301, //  Pagamento Online Takeat
    50629, // Cupom iFood
    BANESTES_METHOD, // Pagar com pontos Banestes
  ];

  function handleFilterMethods(method) {
    if (method.length === 0) {
      setMethodsFiltered([]);
      return;
    }

    const paymentsMethodsFiltered = paymentMethods.filter(
      (payment) =>
        payment.available && !prohibitedPaymentMethods.includes(payment.id)
    );

    if (method.length >= 2) {
      const productsFound = paymentsMethodsFiltered.filter((item) =>
        item.label
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .includes(
            method
              .toLowerCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
          )
      );

      setMethodsFiltered(productsFound);
    }
  }

  useEffect(() => {
    if (rest) {
      setValue(rest);
    } else {
      setValue(0);
    }
  }, [rest]);

  function extractAllOrders(bills) {
    const allOrders = [];

    bills.forEach((bill) => {
      if (bill.order_baskets && Array.isArray(bill.order_baskets)) {
        bill.order_baskets.forEach((basket) => {
          if (basket.orders && Array.isArray(basket.orders)) {
            allOrders.push(...basket.orders);
          }
        });
      }
    });

    return allOrders;
  }

  const bills = extractAllOrders(balconySession?.bills);

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <Container>
      <PaymentsPinpadHeader>
        <h3>Carrinho</h3>
        <BackBalconyButton onClick={() => handleSelectedPaymentComponent()}>
          <BackIcon />
          Cancelar pedido
        </BackBalconyButton>
      </PaymentsPinpadHeader>
      <ProductsContainerBox>
        {bills?.map(({ details, amount, product, complement_categories }) => (
          <div>
            <span>
              {amount}x {product?.name}
            </span>
            {complement_categories?.length !== 0 && (
              <ProductsContainerBoxComplements>
                {complement_categories?.map(({ order_complements }) =>
                  order_complements.map(({ complement }) => {
                    return (
                      <ComplementTag style={{ width: 'fit-content' }}>
                        {complement?.name}
                      </ComplementTag>
                    );
                  })
                )}
              </ProductsContainerBoxComplements>
            )}
            {details && (
              <Comment>
                <BsChat />
                <span>{details}</span>
              </Comment>
            )}
          </div>
        ))}
      </ProductsContainerBox>
      <AreaSeparator />
      <ValuesArea>
        <Value>
          <span>Total</span>
          <span>
            <b>{formatValue(totalToShow || 0)}</b>
          </span>
        </Value>
        <Value>
          <span>{getLeftName()}</span>
          <span>
            <b>{formatValue(Math.abs(rest) || 0)}</b>
          </span>
        </Value>
        <CurrencyInput
          id="value"
          value={value * 100}
          disabled={rest === 0 || rest < 0}
          onChange={(e) => {
            setValue(e.floatValue ? e.floatValue / 100 : 0);
          }}
        />
      </ValuesArea>

      <PaymentsOptions>
        <AddPaymentForm>
          <h4
            style={{
              color:
                value === 0.0 ||
                  value < 0.0 ||
                  value === '0.00' ||
                  value === '0'
                  ? ''
                  : '#c8131b',
              display: 'flex',
              flexDirection: 'row',
              gap: '5px',
            }}
          >
            Maquininha/PIN pad
            <TransparentTooltip
              placement="top"
              title={
                <TooltipPinpadStyled>
                  Use o PIN pad conectado ao computador para processar o
                  pagamento.
                </TooltipPinpadStyled>
              }
              arrow={false}
              children={
                <div>
                  {value === 0.0 ||
                    value < 0.0 ||
                    value === '0.00' ||
                    value === '0' ? (
                    <DisabledAlert
                      id="TooltipExample"
                      style={{
                        position: 'relative',
                        bottom: '1px',
                        cursor: 'pointer',
                      }}
                    />
                  ) : (
                    <Alert
                      id="TooltipExample"
                      style={{
                        position: 'relative',
                        bottom: '1px',
                        cursor: 'pointer',
                      }}
                    />
                  )}
                </div>
              }
            />
          </h4>

          <main>
            {[
              { method: 'Crédito', id: 'credit' },
              { method: 'Débito', id: 'debit' },
              { method: 'Vouncher', id: 'vouncher' },
            ].map(({ id, method }) => (
              <div
                key={id}
                onClick={() => {
                  // onResetPinpadOperation();
                  if ((rest < value)) {
                    toast.error(
                      'Valor selecionado é maior do que débito corrente.'
                    );
                    return;
                  }

                  onStartPinpadPayment({
                    amount: Number(value),
                    paymentMethod: id,
                    userId: user.user_id,
                    token,
                    // tableSessionId: session.table.id
                    tableSessionId: balconySession.session.id,
                    channel: 'pinpad',
                  });
                }}
              >
                <StyledMaquininhaButton
                  disabled={
                    value === 0.0 ||
                    value < 0.0 ||
                    value === '0.00' ||
                    value === '0'
                  }
                  style={{
                    width: '130px',
                  }}
                >
                  {method}
                </StyledMaquininhaButton>
              </div>
            ))}
          </main>
          <section />
          <h4>Métodos de pagamento - sem Pinpad</h4>
          <div>
            {favoriteMethods
              .filter(
                (method) =>
                  method.available &&
                  !prohibitedPaymentMethods.includes(method.keyword)
              )
              .map((method) => {
                return (
                  <NewButton
                    style={{
                      color: '#545454',
                      width: '130px',
                    }}
                    customColor="#F6F6F6"
                    disabled={
                      (paymentsSession?.filter(
                        (pay) => pay?.keyword === 'prazo'
                      ).length > 0 &&
                        user.credit_register_with_nfce) ||
                      loading
                    }
                    isLoading={loading}
                    onClick={async () => {
                      if ((rest < value) && method.keyword !== 'dinheiro') {
                        toast.error(
                          'Valor selecionado é maior do que débito corrente.'
                        );
                        return;
                      }

                      if (
                        user.has_stone_pdv &&
                        ['CREDIT', 'DEBIT', 'credit', 'debit'].includes(
                          allPaymentMethods.find((pay) => pay.id === method.id)
                            ?.method || false
                        ) &&
                        checkStonePending
                      ) {
                        toast.error(
                          'Pagamento pendente na maquininha, aguarde a confirmação ou cancele o pagamento'
                        );
                        return;
                      }

                      const paymentPackage = {
                        payment_value: value,
                        table_session_id: balconySession.session.id,
                        payment_method_id: method.id,
                        rescues: [],
                      };

                      setLoading(true);
                      try {
                        await savePaymentAsync(paymentPackage);
                        await getPayments(balconySession?.session?.id);
                      } catch (error) {
                        if (error.response && error.response.data) {
                          toast.error(error.response.data.message);
                        } else {
                          toast.error('Erro ao salvar pagamento');
                        }
                      } finally {
                        setLoading(false);
                      }
                    }}
                  >
                    {method.label}
                  </NewButton>
                );
              })}
            {paymentMethods.length > 0 && favoriteMethods.length >= 2 && (
              <Dropdown
                // disabled={checkStonePending}
                isOpen={dropdownOpen}
                toggle={toggleDrop}
              >
                <DropDowxStyledButton
                  onClick={toggleDrop}
                  customColor="#F6F6F6"
                  width={130}
                  style={{
                    color: '#545454 !important',
                  }}
                >
                  {metodo}
                  <ChevronDown />
                </DropDowxStyledButton>
                <div
                  style={{
                    display: 'flex',
                    position: 'relative',
                    left: '-120px',
                  }}
                >
                  <DropdownMenu style={{ overflowY: 'scroll', height: 300 }}>
                    <IconInput
                      color="#6c6c6c"
                      placeholder="Buscar"
                      isClearable
                      deleteButton={() => setMethodsFiltered([])}
                      containerStyles={{
                        height: 40,
                        border: 'none',
                        borderBottom: '1px solid #6c6c6c',
                        borderRadius: 0,
                      }}
                      onChange={(e) => {
                        handleFilterMethods(e.target.value);
                      }}
                    />
                    {methodsFiltered && methodsFiltered.length > 0
                      ? methodsFiltered.map((payment) => (
                        <DropdownItem
                          onClick={() => setMetodoAndPaymentOption(payment)}
                          disabled={
                            paymentsSession.filter(
                              (pay) => pay?.keyword === 'prazo'
                            ).length > 0 && user.credit_register_with_nfce
                          }
                        >
                          {payment.label}
                        </DropdownItem>
                      ))
                      : paymentMethods.map((payment) =>
                        !prohibitedPaymentMethods.includes(payment.id) ? (
                          <div key={payment.id}>
                            <DropdownItem
                              disabled={
                                paymentsSession.filter(
                                  (pay) => pay?.keyword === 'prazo'
                                ).length > 0 && user.credit_register_with_nfce
                              }
                              onClick={async () => {
                                if ((rest < value) && payment.keyword !== 'dinheiro') {
                                  toast.error(
                                    'Valor selecionado é maior do que débito corrente.'
                                  );
                                  return;
                                }

                                const paymentPackage = {
                                  payment_value: value,
                                  table_session_id: balconySession.session.id,
                                  payment_method_id: payment.id,
                                  rescues: [],
                                };

                                await savePaymentAsync(paymentPackage);
                                getPayments(balconySession?.session?.id);
                              }}
                            >
                              {payment.label}
                            </DropdownItem>
                          </div>
                        ) : (
                          <></>
                        )
                      )}
                  </DropdownMenu>
                </div>
              </Dropdown>
            )}
          </div>
        </AddPaymentForm>
      </PaymentsOptions>
      <PaymentsMade>
        <thead>
          <th>Método de pgto</th>
          <th>Valor</th>
          <th style={{ textAlign: 'right' }}>Ação</th>
        </thead>
        <tbody>
          {payments?.length > 0 ? (
            payments.map((payment) => {
              const method =
                payment.payment_method_id === CLUBE_METHOD
                  ? { label: 'Resgate Clube', id: CLUBE_METHOD }
                  : payment.payment_method_id === BANESTES_METHOD
                    ? { label: 'Resgate Banestes', id: BANESTES_METHOD }
                    : allPaymentMethods.find(
                      (method) =>
                        method.available &&
                        method.id === payment.payment_method_id
                    );

              return (
                <PaymentRow
                  key={payment.id}
                  payment={payment}
                  method={method}
                  stoneTransactions={stoneTransactions}
                  allPaymentMethods={allPaymentMethods}
                  handleStoneTransactions={handleStoneTransactions}
                  loadingPos={loadingPos}
                  toggleCancelPos={toggleCancelPos}
                  getPayments={getPayments}
                  balconySession={balconySession}
                />
              );
            })
          ) : (
            <tr>
              <td colSpan={3}>Nenhum pagamento adicionado</td>
            </tr>
          )}
        </tbody>
        {user.has_stone_pdv && user.stone_device_id && checkStonePending && (
          <Hyperlink
            color="#2EC9B7"
            fontSize={12}
            textDecoration="underline"
            onClick={handleCancelPendingPos}
          >
            Cancelar Pagamentos Pendentes POS
          </Hyperlink>
        )}
      </PaymentsMade>

      <ValuesArea>
        <Value>
          <span>
            <b>Total pago</b>
          </span>
          <span>{formatValue(total_payments)}</span>
        </Value>
        <Value style={{ alignItems: 'flex-end' }}>
          <span>
            <b>Pago</b>
          </span>
          <span>
            {(totalToShow <= 0
              ? '0'
              : total_payments / totalToShow > 1
                ? '100'
                : (total_payments / totalToShow) * 100
            ).toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
            %
          </span>
        </Value>
      </ValuesArea>

      <Modal isOpen={modalCancelPos} toggle={toggleCancelPos}>
        <ModalBody style={{ padding: 20 }}>
          <Row style={{ paddingTop: 15 }}>
            <Col md="12">Deseja cancelar esse pagamento na POS?</Col>
          </Row>
        </ModalBody>
        <ModalFooter style={{ marginLeft: 'auto' }}>
          <Button
            title="Sim, cancelar"
            buttonColor="#2ec9b7"
            disabled={loadingPos}
            onClick={(e) => handleCancelStoneTransactions()}
          />
        </ModalFooter>
      </Modal>
    </Container>
  );
};
